<div class="full-bg">
    <div class="gif-wrapper">
        <img loading="lazy" src="/assets/icons/new-loading.gif">
    </div>
</div>
